import { useLanguage } from "../context/LanguageContext";
import React from "react";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Features from "../components/Features";
import Testimonials from "../components/Testimonials";
import CTA from "../components/CTA";
import Footer from "../components/Footer";

const HomePage = () => {
  const { language } = useLanguage();

  return (
    <>
      <Hero language={language} />
      <Services />
      <Features />
      <Testimonials />
      <CTA language={language} />
      <Footer language={language} />
    </>
  );
};

export default HomePage;
